export class HomepageProjectLatestUsers {
  /**
   *
   */
  public account_id: number | null = null;

  /**
   *
   */
  public account_lid: string | null = null;

  /**
   *
   */
  public account_firstname: string | null = null;

  /**
   *
   */
  public account_lastname: string | null = null;
}
